import { Helmet } from 'react-helmet';

type Props = {
  title: string;
};

export const MetaTitle = ({ title }: Props) => (
  <Helmet>
    <title>{title}</title>
    <meta content={title} name="title" />
    <meta property="og:title" content={title} />
  </Helmet>
);
